import agent from '../agent'
import {
    ORGS_COMMENTS_LIST_LOADED,
    ORGS_COMMENTS_LIST_UNLOADED,
    ORGS_ADD_COMMENT_TO_COMMENTS_LIST
} from "../constants/actionTypes"

export const orgsCommentsListLoaded = (payload) => ({
    type: ORGS_COMMENTS_LIST_LOADED,
    payload
})

export const orgsCommentsListUnloaded = () => ({
    type: ORGS_COMMENTS_LIST_UNLOADED
})

export const orgsLoadCommentsList = (dispatch) => (Id) => {
    agent.OrgsComments.getOrgsCommentsList(Id).then(res => {
        dispatch(orgsCommentsListLoaded(res));
    }, err => {
        dispatch(orgsCommentsListLoaded({
            hasError: true,
            error: (((err.response || {}).body || {}).responseStatus || {}).message || ""
        }));
    })
}

export const orgsAddCommentDispatch = (payload) => ({
    type: ORGS_ADD_COMMENT_TO_COMMENTS_LIST,
    payload
})

export const orgsAddCommentToCommentsList = (dispatch, getState) => (comment) => {
    let store = getState();
    // let commentsList = store.commentsList.list
    let commentsList = store.OrgsCommentsList.list
    let newCommentList = [...commentsList, comment]
    dispatch(orgsAddCommentDispatch(newCommentList));
}

export const orgsReplaceCommentToCommentsList = (dispatch, getState) => (newComment) => {
    let store = getState();
    // let commentsList = store.commentsList.list
    let commentsList = store.OrgsCommentsList.list
    commentsList = commentsList.map(comment=> {
        if (comment.id  === newComment.id) {
            return newComment
        }
        return comment
    })
    dispatch(orgsAddCommentDispatch(commentsList));
}

export const orgsUnloadCommentsList = (dispatch) => () => {
    dispatch(orgsCommentsListUnloaded());
}

